/* eslint-disable react/prop-types */
import React from 'react';

import {
  Table,
  TableContainer,
  TableRow,
  TableBody,
  TableCell,
  Paper,
  Box,
} from '@mui/material';

import NoImage from '../../../../../assets/images/no_image.png';
import { CustomTableHead } from './styles';

export function ItemsTable({ orderDetails }) {
  return (
    <Box sx={{ padding: '20px 0 0 0', width: '100%' }}>
      <TableContainer component={Paper} sx={{ maxHeight: '400px' }}>
        <Table stickyHeader>
          <CustomTableHead>
            <TableRow>
              <TableCell align="center" sx={{ color: 'white' }}>
                Imagem
              </TableCell>
              <TableCell align="center" sx={{ color: 'white' }}>
                Nome
              </TableCell>
              <TableCell align="center" sx={{ color: 'white' }}>
                Categoria
              </TableCell>
              <TableCell align="center" sx={{ color: 'white' }}>
                Quantidade
              </TableCell>
              <TableCell align="center" sx={{ color: 'white' }}>
                Motivo
              </TableCell>
              <TableCell align="center" sx={{ color: 'white' }}>
                Resolução
              </TableCell>
              <TableCell align="center" sx={{ color: 'white' }}>
                Valor
              </TableCell>
            </TableRow>
          </CustomTableHead>
          <TableBody>
            {orderDetails.items.map((item) => (
              <TableRow key={item.id}>
                <TableCell align="center" sx={{ color: 'white' }}>
                  <img
                    src={item.imageUrl ? item.imageUrl : NoImage}
                    alt="Item pic"
                    width="90px"
                    height="90px"
                  />
                </TableCell>
                <TableCell align="center">{item.name}</TableCell>
                <TableCell align="center">{item.category.name}</TableCell>
                <TableCell align="center">{item.quantity}</TableCell>
                <TableCell align="center">
                  {item.reason ? item.reason.description : 'N/A'}
                </TableCell>
                <TableCell align="center">
                  {item.resolution ? item.resolution : 'N/A'}
                </TableCell>
                <TableCell align="center">
                  {`R$${parseFloat(item.price).toFixed(2)}`.replace('.', ',')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
